// extracted by mini-css-extract-plugin
module.exports = {"SwipeLeftToClose":"beo_a bhl_bk bhl_bl bhl_bo","SwipeLeftToClose--animating":"beo_b"};